<template>
    <div class="chatr-footer" v-if="value">
        <div class="chatr-footer__item">
            всего <span class="chatr-footer__cercle">{{value.all_chat}}</span>
        </div>
        <div class="chatr-footer__item">
            Новые <span class="chatr-footer__cercle chatr-footer__cercle_color_green">
                {{ value.new_chat }}
            </span>
        </div>
        <div class="chatr-footer__item">
            Завершенные <span class="chatr-footer__cercle chatr-footer__cercle_color_grey">
                {{ value.closed_chat }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value: ''
    },
    data () {
        return {}
    }
}
</script>